import { render, staticRenderFns } from "./slick-banner.vue?vue&type=template&id=a6e7e798"
import script from "./slick-banner.vue?vue&type=script&lang=js"
export * from "./slick-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports